import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  ADD_CONTACT,
  ADDING_PARTNER_CONTACT,
  ADD_PARTNER_CONTACT,
  UPDATE_CONTACT,
  FIND_CONTACT,
  POST_SURVEY,
  SET_FILTERED_SURVEYS,
  SET_COMPLETED_QUALIFIED_SURVEYS,
} from './actionTypes';

import { API_ENDPOINT } from '../constants';

export {
  getCsrfToken,
  getUserById,
  signingUpUser,
  signUpUser,
  loggingInUser,
  loggedInUser,
  updatingUserInfo,
  updateUserInfo,
  setUserInfo,
  clearLoggedInErrorMessage,
  loggedOutUser,
  forgetPassword,
  post_resetPassword,
  handleAuthCallbacks,
} from './usersActions';

export {
  getVehicleMakeAndModelInfo,
  receivedVehicleMakeAndModelInfo,
  getVehicleModelInfo,
  getPropertyAndOccupancyInfo,
  checkingRates,
  checkUserFilterRates,
  updateVehicleInfo,
  updatePropertyInfo,
} from './autoHomeRatesActions';

export {
  getUserEmploymentInfo,
  updateUserEmploymentInfo,
  createUserEmploymentInfo,
  patchUserEmploymentInfo,
} from './employmentActions';

export {
  updateUserResidencyInfo,
  getUserResidencyInfo,
  createUserResidencyInfo,
  patchUserResidencyInfo,
} from './residencyActions';

export {
  updateUserAssetsAndNetWorthInfo,
  getUserAssetInfo,
  updateUserLiabilitiesAndNetWorthInfo,
  createUserAssetInfo,
  createUserLiabilityInfo,
  updateUserAssetInfo,
  getUserLiabilityInfo,
} from './assetsLiabilitiesActions';

// POST CONTACT
export const addContacts = createAsyncThunk(ADD_CONTACT, async ({ body, token }, methods) => {
  const { dispatch } = methods;
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  let response;
  try {
    response = await axios.post(`${API_ENDPOINT}/add_contact`, body, { headers });
  } catch (error) {
    console.error('error adding contact', error);
  }
  dispatch({ type: ADD_CONTACT, payload: response?.data });
});

export const addingPartnerContacts = (dispatch) => {
  dispatch({ type: ADDING_PARTNER_CONTACT });
};

// POST PARTNER CONTACT
export const addPartnerContacts = createAsyncThunk(
  ADD_PARTNER_CONTACT,
  async ({ body, token }, methods) => {
    const { dispatch } = methods;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let response;

    try {
      response = await axios.post(`${API_ENDPOINT}/add_partner_contact`, body, { headers });
    } catch (error) {
      console.error('error adding contact', error);
    }
    dispatch({ type: ADD_PARTNER_CONTACT, payload: response?.data });
  },
);

//GET CONTACT
export const findContacts = createAsyncThunk(FIND_CONTACT, async (email, methods) => {
  const { dispatch } = methods;
  let response;
  try {
    response = await axios.get(`${API_ENDPOINT}/contact/${email}`);
    return response;
  } catch (error) {
    console.error('error finding contact', error);
  }
  dispatch({ type: FIND_CONTACT, payload: response?.data });
});

export const updateContact = createAsyncThunk(
  UPDATE_CONTACT,
  async ({ id, contactData }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      response = await axios.patch(`${API_ENDPOINT}/contact/${id}`, contactData);
    } catch (error) {
      console.error('error updating contact', error);
    }
    dispatch({ type: UPDATE_CONTACT, payload: response?.data });
  },
);

//post survey
export const postSurvey = createAsyncThunk(
  POST_SURVEY,
  async ({ surveyType, surveyData, token, user }, methods) => {
    const { dispatch } = methods;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let response;
    try {
      response = await axios.post(
        `${API_ENDPOINT}/surveySubmitted`,
        {
          surveyType,
          surveyData,
          user,
        },
        { headers },
      );
      return response.data;
    } catch (error) {
      console.error('error posting survey', error);
    }

    dispatch({ type: POST_SURVEY, payload: response?.data });
  },
);

export const getFilteredSurveys = createAsyncThunk(
  SET_FILTERED_SURVEYS,
  async ({ params = {}, token }, methods) => {
    const { dispatch } = methods;

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    try {
      const res = await axios.get(`${API_ENDPOINT}/survey/filter`, { params, headers });
      dispatch({ type: SET_FILTERED_SURVEYS, payload: res.data });

      return res.data;
    } catch (error) {
      console.error('Error getting filtered surveys:', error);
      throw error;
    }
  },
);

export const getCompletedQualifiedSurveys = createAsyncThunk(
  SET_COMPLETED_QUALIFIED_SURVEYS,
  async ({ params = {}, token }, methods) => {
    const { dispatch } = methods;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    let res;
    try {
      res = await axios.get(`${API_ENDPOINT}/survey/completed/qualified`, { params, headers });
      dispatch({ type: SET_COMPLETED_QUALIFIED_SURVEYS, payload: res.data });
      return res.data;
    } catch (error) {
      console.error('Error getting completed qualified surveys:', error);
    }
  },
);
